import React, { useState } from 'react';
import '../Student/RequestPass.css';
import { useNavigate } from 'react-router-dom';
import AcceptPage from './AcceptPage';
import axios from 'axios';

const OTPverify = () => {
  const [roll, setRoll] = useState("");
  const [otp, setOTP] = useState("");

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const headers = {
        'Authorization': localStorage.getItem("token"),
        'Content-Type': 'application/json',
      };
      const body = {
        otp : otp,
        rollNo : roll,
      };
      console.log(body);
      const data = await axios.post(`${process.env.REACT_APP_API_URL}api/v1/guard/find`,body,{headers});
      console.log(data);
      if(data.data === "") {
        alert("Something went wrong. Please try again!!");
        window.location.reload();
      }
      // if (!response.ok) {
      //   throw new Error('Failed to find outpass');
      // }
      // console.log('Outpass found!!');
      localStorage.setItem("pass", JSON.stringify(data.data));
      navigate('/guard/accept');
      // Optionally, you can reset the form fields here
      // setOTP("");
    } catch (error) {
      console.error('Error in finding outpass:', error);
    }
  };

  return (
   <>
    <div className="request-pass" style={{marginTop:"100px"}}>
      <h2 style={{textAlign:"center"}}>OTP Verification</h2>
      <form onSubmit={handleSubmit}>
      <div className="input-row" style={{width:"100%"}}>
          <div className="input-group">
            <label>Enrollment no:</label>&nbsp;
            <input type="text" name="roll" value={roll} onChange={(e)=>{setRoll(e.target.value)}} />
          </div>
        </div>
        <div className="input-row" style={{width:"100%"}}>
          <div className="input-group">
            <label>Enter OTP:</label>&nbsp;
            <input type="text" name="otp" value={otp} onChange={(e)=>{setOTP(e.target.value)}} />
          </div>
        </div>
       
        <button type="submit">Submit</button>
      </form>
    </div>
    </>
   

  );
};

export default OTPverify;